jQuery(document).ready(function ($) {
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            $('body').addClass('scrolled');
        } else {
            $('body').removeClass('scrolled');
        }
    });
});

// jQuery(document).ready(function ($) {
//     // Handle hover on desktop
//     $('.menu-item.dropdown').hover(
//         function () {
//             const $dropdown = $(this);
//             $dropdown.addClass('show');
//             $dropdown.children('.dropdown-toggle').addClass('show').attr('aria-expanded', 'true');
//             $dropdown.children('.dropdown-menu').addClass('show');
//         },
//         function () {
//             const $dropdown = $(this);
//             $dropdown.removeClass('show');
//             $dropdown.children('.dropdown-toggle').removeClass('show').attr('aria-expanded', 'false');
//             $dropdown.children('.dropdown-menu').removeClass('show');
//         }
//     );
// });
import Tab from 'bootstrap/js/dist/tab'

document.addEventListener('DOMContentLoaded', () => {
    const tabLinks = document.querySelectorAll('#caseTabs a[data-bs-toggle="tab"]');
    const tabContent = document.getElementById('caseTabsContent');
    if (!tabContent || tabLinks.length === 0) {
        return;
    }
    function resetAnimations() {
        tabContent.querySelectorAll('.tab-pane').forEach(pane => {
            pane.querySelectorAll('.tab-title, .tab-desc, .tab-desc-svg, .tab-button, .tab-image, .case-stats .stat-item').forEach(el => {
                el.style.opacity = '0';
                el.style.transform = 'translateX(80px)';
                // el.style.transition = 'none';
            });
        });
    }

    function triggerStaggeredAnimation(activePane) {
        const elements = [
            { el: activePane.querySelector('.tab-title'), delay: 0 },
            { el: activePane.querySelector('.tab-desc'), delay: 200 },
            { el: activePane.querySelector('.tab-desc-svg'), delay: 300 },
            { el: activePane.querySelector('.tab-button'), delay: 400 },
            { el: activePane.querySelector('.tab-image'), delay: 600 },
        ];

        elements.forEach(({ el, delay }) => {
            if (el) {
                setTimeout(() => {
                    el.style.opacity = '1';
                    el.style.transform = 'translateX(0)';
                }, delay);
            }
        });

        activePane.querySelectorAll('.case-stats .stat-item').forEach((stat, i) => {
            setTimeout(() => {
                stat.style.opacity = '1';
                stat.style.transform = 'translateY(0)';
            }, 1000 + i * 180);
        });
    }

    tabLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetPane = document.querySelector(targetId);
            const currentActive = tabContent.querySelector('.tab-pane.active');

            resetAnimations();

            if (currentActive && currentActive !== targetPane) {
                currentActive.classList.add('fade-out');
                setTimeout(() => currentActive.classList.remove('active', 'fade-out'), 400);
            }

            setTimeout(() => {
                targetPane.classList.add('active');
                Tab.getOrCreateInstance(this).show();
                triggerStaggeredAnimation(targetPane);
            }, currentActive ? 400 : 0);
        });
    });

    function updateHeight() {
        let maxHeight = 0;
        tabContent.querySelectorAll('.tab-pane').forEach(pane => {
            pane.style.position = 'relative';
            pane.style.opacity = '1';
            pane.style.visibility = 'visible';
            maxHeight = Math.max(maxHeight, pane.offsetHeight);
            pane.style.cssText = '';
        });
        tabContent.style.minHeight = (maxHeight + 120) + 'px';
    }

    updateHeight();
    const firstPane = tabContent.querySelector('.tab-pane.active');
    if (firstPane) triggerStaggeredAnimation(firstPane);
    tabLinks.forEach(t => t.addEventListener('shown.bs.tab', updateHeight));
});
